import type { OrganizationsListRow } from "@/admin/entities/organizations";
import type { OrganizationUsersListRow } from "@/admin/entities/organizationUsers";
import type { OrganizationsListQueryType } from "@/types/graphql/admin.generated";

/**
 * Мапперы для feature управления организациями
 * Используют конкретные типы из GraphQL кодгена
 */

// Трансформация данных GraphQL ответа в формат для таблицы
// CRUD компонент ожидает (data: unknown) => TableData<Row>
export function getTableData(data: unknown): {
  nodes: OrganizationsListRow[];
  count: number;
} {
  const organizations = (data as OrganizationsListQueryType)?.organizations;

  if (!organizations || !organizations.nodes) {
    return { nodes: [], count: 0 };
  }

  return organizations;
}

// Маппинг данных организации в формат для отображения в таблице
export function mapColumns(organization: OrganizationsListRow) {
  return [organization.id, organization, organization.createdAt];
}

export function mapOrganizationUsersColumns(user: OrganizationUsersListRow) {
  return [user.id, user, user, user.createdAt];
}
